import React, { Component } from 'react';
import { connect } from '@common/components/base.component';
import autoBind from 'react-autobind';

import navbarActions from '@common/store/navbar/navbar.actions';
import navbarSelectors from '@common/store/navbar/navbar.selectors';

import Brasao from '@common/components/brasao/brasao.component';
import * as commonActionType from '@common/store/common/common.actionsType';

import { Layout } from 'antd';

import IconButton from '@material-ui/core/IconButton';
import MenuOpenIcon from '@material-ui/icons/MenuOpenRounded';
import MenuIcon from '@material-ui/icons/MenuRounded';

import NavbarSearch from '@common/components/navbar/search/navbar.search';
import NavbarSystems from '@common/components/navbar/systems/navbar.systems';
import NavbarUser from '@common/components/navbar/user/navbar.user';
import NavbarFavorite from '@common/components/navbar/favorite/navbar.favorite';
import AccessControl from '@common/components/accessControl/accessControl.component';

class HeaderLayout extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      applyShadow: false,
      hasIdOnUrl: false,
    };
  }

  toggleMenuOnRedirect() {
    const { menuCollapse } = this.props.navbarSelectors;
    if (menuCollapse.toggleMenu) this.props.navbarActions.toggleMenu();
  }

  componentDidMount() {
    PubSub.subscribe(commonActionType.CLOSE_MENU, this.toggleMenuOnRedirect.bind(this));
    window.addEventListener('scroll', this.onScroll);
  }

  onScroll(e) {
    if (window.scrollY > 25) this.setState({ applyShadow: true });
    else this.setState({ applyShadow: false });
  }

  render() {
    const { menuCollapse } = this.props.navbarSelectors;
    const hasIdOnUrl = this.props.routerManager.currentUrl.match(/[0-9]+/);

    return (
      <Layout.Header className={this.state.applyShadow ? 'header-float' : ''}>
        <IconButton
          aria-label="menu"
          style={{ marginLeft: '20px', outline: 'none' }}
          onClick={this.props.navbarActions.toggleMenu}
        >
          {menuCollapse.toggleMenu ? <MenuOpenIcon /> : <MenuIcon />}
        </IconButton>
        <Brasao />
        <div className="float-right d-inline-block ml-auto mr-4 mt-3">
          <NavbarSearch />
          <AccessControl url="#/usuario/favoritos">
            <NavbarFavorite 
              activeClick={!(hasIdOnUrl || (window.location.hash.endsWith('/')))}
            />
          </AccessControl>
          <NavbarSystems />
          <NavbarUser />
        </div>
      </Layout.Header>
    );
  }
}

export default connect({
  selectors: {
    navbarSelectors,
  },
  actions: {
    navbarActions,
  },
})(HeaderLayout);
